// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"72e918e2","430":"72e918e2","641":"72e918e2","947":"adc61bbf"}[chunkId] + ".chunk.css";
};